<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="id"
						label="序号"
					>
					</el-table-column>
					<el-table-column
						prop="link"
						label="链接"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="publisher"
						label="发布人"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
		
		<!-- 新增轮播 -->
		<add 
			v-model="add_display"
			@onSuccess="addSuccess"
		></add>
		<!-- 新增轮播 end -->
		
		<!-- 查看轮播 -->
		<view-swiper 
			v-model="view_display"
			:obj="view_data"
		></view-swiper>
		<!-- 查看轮播 end -->
		
		<!-- 新增轮播 -->
		<update 
			v-model="update_display"
			:obj="update_data"
			@onSuccess="updateSuccess"
		></update>
		<!-- 新增轮播 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import ViewSwiper from './components/view.vue';
	import Update from './components/update.vue';
	import Api from '../../../../../../api/index.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				tableData: [],
				
				add_display: false,
				
				view_display: false,
				view_data: {},
				
				update_display: false,
				update_data: {}
			}
		},
		methods: {
			/******************** @Events *************************/
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击查看
			handleViewClick(data) {
				this.view_data = {...data};
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 新增成功
			addSuccess() {
				this.getData();
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该轮播图，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteSwiper(obj.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************** @Function *************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				Api.findAppHomeSwiper().then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.forEach(v => {
							list.push({
								id: v.bannerId,
								title: v.bannerTitle,
								link: v.linkUrl,
								time: v.createTs,
								publisher: v.buserName,
								banner: v.bannerUrl
							});
						});
						that.tableData = list;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除轮播图
			deleteSwiper(id) {
				const that = this;
				that.loading = true;
				Api.deleteAppHomeSwiper(id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.getData();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			ViewSwiper,
			Update
		}
	}
</script>

<style>
</style>
